import { Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IRole } from 'src/app/models/IRole';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { IAttributes } from 'src/app/models/IAttributes';
import { UserManagementService } from 'src/app/Services/UserManagement/user-management.service';
import { ToastrService } from 'ngx-toastr';
import { Guid } from "guid-typescript";
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Router } from '@angular/router';
import { InputDialogComponent } from 'src/app/ChildControls/input-dialog/input-dialog.component';
import { MatDialog } from '@angular/material';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { DatePipe } from '@angular/common';
declare var $: any;

interface Food {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  foods: Food[] = [
    { value: 'steak-0', viewValue: 'Test1' },
    { value: 'pizza-1', viewValue: 'Test2' },
    { value: 'tacos-2', viewValue: 'Test3' }
  ];
  userDetailsInfo: IUserDetails;
  public creationResult: string;
  public userId: string;
  popUpText: string;
  UserDetailsForm: FormGroup;
  public roles: IRole[];
  public userInfo: any;
  public gender: IAttributes[];
  public securityQuestion: IAttributes[];
  public id: Guid;
  public submitted: boolean = false;
  public salutation: IAttributes[];
  hide = true;
  SelectedDropDownListId: boolean = false;
  //selectedLocationsIdsUpdate: number[]=[];
  arryOfselectedLocationsIdsUpdate: string[] = [];
  @Output() addedUserSuccess = new EventEmitter<any>();
  @ViewChild('saveUserId', { static: false }) saveUserId: ElementRef;


  @HostListener("document:click", ['$event'])
  documentClickListner(event) {
    if (event.target.id == "locationsfocus" || event.currentTarget.activeElement.parentElement.id == "userselectLoc") {
      this.SelectedDropDownListId = true
    }
    else {
      event.stopPropagation();
      this.SelectedDropDownListId = false
    }
  }
  
  constructor(private fb: FormBuilder, //private app: AppComponent,
    private router: Router, private userService: UserManagementService,
    private toastr: ToastrService, private sharedService: SharedService, public dialog: MatDialog, private crypto: AESAlgorithm
    , public datepipe: DatePipe, private schedulerservice: SchedularServiceService) {
    // app.isLoggedIn$ = true;
    this.getRoles(); this.userDetailsDropDownsBinding();
  }

  ngOnInit() {

    // $('#locationsfocus').on('focus', function () {
    //   $('#locationsfocushide').show();
    // });
    // $(document).click(function (event) {
    //    
    //   if (event.target.id != "locationsfocus") {
    //     var container = $("#locationsfocushide");
    //     if (!container.is(event.target) && !container.has(event.target).length) {
    //       container.hide();
    //       this.SelectedDropDownListId = false;
    //     }
    //   } else {
    //     this.SelectedDropDownListId = true;
    //   }
    // });


    this.UserDetailsForm = this.fb.group({
      lastName: ['', [Validators.required, Validators.pattern("[a-zA-Z\' ]*$"), Validators.maxLength(60)]],
      middleName: ['', [Validators.pattern("[a-zA-Z\' ]*$"), Validators.maxLength(50)]],
      firstName: ['', [Validators.required, Validators.pattern("[a-zA-Z\' ]*$"), Validators.minLength(3), Validators.maxLength(50)]],
      email: ['', [Validators.email, Validators.maxLength(80)]],
      cellPhone: [''],
      gender: ['', Validators.required],
      securityQuestion: [''],
      answer: [''],
      effectiveDate: ['', Validators.required],
      userId: ['', [Validators.required, Validators.pattern("^[A-Za-z0-9]+$"), Validators.maxLength(12)]],
      password: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9~!@#$%^*&;?.+_]+$"), Validators.maxLength(16)]],
      role: ['', Validators.required],
      availbility: ['', Validators.required],
      ASC: [''],
      billing: [''],
      clinic: [''],
      supervisingAccess: [''],
      epcs: [''],
      salutation: ['', [Validators.required]],
      locations: ['', Validators.required],
      primaryLocation: [''],

    });

    this.userDetailsInfo = {
      userId: '',
      ASC: null,
      clinic: null,
      billing: null,
      userPassword: '',
      newPassword: '',
      salt: '',
      ssn: '',
      designation: '',
      lastName: '',
      middleName: '',
      firstName: '',
      userGender: '',
      userDob: null,
      maritalStatus: '',
      photo: '',
      salutation: '',
      ownQuestion: '',
      securityQuestion: '',
      securityAnswer: '',
      startDate: null,
      endDate: null,
      isDragonEnabled: null,
      isLocked: null,
      isActive: null,
      createdBy: '',
      createdOn: null,
      modifiedBy: '',
      modifiedOn: null,
      addressId: null,
      roleId: '',
      permissionCode: '',
      permissionId: '',
      roleName: '',
      usercarriers: [],
      fullName: '',
      dbOperation: '',
      isExternal: null,
      passwordReset: null,
      name: '',
      userAddressDetails: null,
      wrongAttempts: null,
      clinicWrongAttempts: null,
      txtColVisiblity: null,
      passwordCaseSensitivity: null,
      passwordExpiryPeriod: null,
      currentDate: null,
      serverDate: null,
      signatureSizeImage: '',
      userNameSpaceId: '',
      userUid: '',
      userUidType: '',
      userNameTypeCode: '',
      userIdentifierTypeCode: '',
      userIdentity: null,
      npiNumber: '',
      deaNumber: '',
      tinNumber: '',
      address1: '',
      address2: '',
      address3: '',
      state: '',
      city: '',
      postalCode: '',
      phone: '',
      fax: '',
      providerId: '',
      serviceLevel: '',
      userVerificationCode: '',
      userVerificationInfo: '',
      taxId: '',
      facilityId: null,
      primarySpeciality: '',
      specialityCode: '',
      suffix: '',
      email: '',
      ssProvider: null,
      spi: '',
      locationId: '',
      defaultLocationId: '',
      providerType: '',
      billingLocationId: null,
      paytoLocationId: null,
      payToProviderId: null,
      renderingLocationId: null,
      physician: null,
      supervisingProvider: '',
      isSupervising: null,
      clientId: null,
      appointmentBookingLimit: null,
      manageBillerId: '',
      claimType: '',
      taxonomy: '',
      bpPayerNames: '',
      billProvFullAdrs: '',
      payerIdsMb: '',
      payerNamesMb: '',
      isActiveForManageBiller: null,
      defaultProvider: null,
      postalCodeExt: '',
      stateCode: '',
      client: '',
      securityCode: '',
      status: '',
      staffType: '',
      activeStatus: '',
      claimTypeName: '',
      isPrescriber: null,
      userIdentify: null,
      userName: '',
      epcs: null,
      salutationName: '',
      locationIds: null,
      lstuserlocations: null,
      userLocations: '',
      checkuserSignature: null,
      selected: null,
      isdirect: false,
      directaddress: null
    }

    this.UserDetailsForm.patchValue({
      effectiveDate: new Date()
    })
    this.getLocations();
  }

  getRoles() {
    this.userService.getRoles().subscribe(data => {
      this.roles = data;

    });
  }
  userStatus: any;
  getUserInfo(event) {
    this.userId = this.UserDetailsForm.value.userId;
    if (this.userId != undefined && this.userId != null && this.userId != "") {
      var tempUserId = this.UserDetailsForm.value.userId.toLowerCase();
      //this.userId = encodeURIComponent(this.crypto.encryptor(tempUserId).toString());
      this.userId = encodeURIComponent(tempUserId);
      this.userService.checkUserID(this.userId)
        .subscribe(data => {
          this.userStatus = data;
          if (this.userStatus == "1") {
            this.UserDetailsForm.patchValue(
              {
                availbility: "User already exists"
              });
          }
          else {
            this.UserDetailsForm.patchValue(
              {
                availbility: "User Id is Available"
              });
          }
        });
    }
    else {
      this.toastr.error("User Id can not be null");
    }
  }

  userDetailsDropDownsBinding() {
    this.sharedService.getAttributesById(11).subscribe(data => {
      this.gender = data;
    });

    this.sharedService.getSecurityQuestionById(23).subscribe(data => {
      this.securityQuestion = data;
    });
    this.sharedService.getAttributesById(70).subscribe(data => {
      this.salutation = data;
    });
  }
  owntextresults: string;

  mapFormValuesToUserDetailsModel() {

    this.userDetailsInfo.lastName = this.UserDetailsForm.value.lastName;
    this.userDetailsInfo.middleName = this.UserDetailsForm.value.middleName;
    this.userDetailsInfo.firstName = this.UserDetailsForm.value.firstName;
    this.userDetailsInfo.email = this.UserDetailsForm.value.email;
    //this.userDetailsInfo.phone = this.UserDetailsForm.value.phone;
    this.userDetailsInfo.phone = this.UserDetailsForm.value.cellPhone;
    this.userDetailsInfo.userGender = this.UserDetailsForm.value.gender;
    this.userDetailsInfo.userId = this.crypto.encryptor(this.UserDetailsForm.value.userId.toLowerCase()).toString();
    this.id = Guid.create();
    this.userDetailsInfo.userPassword = this.crypto.encryptPassword(this.UserDetailsForm.value.password, this.id.toString().substring(0, 32)).toString();

    // this.userDetailsInfo.securityQuestion = this.UserDetailsForm.value.securityQuestion;
    this.userDetailsInfo.securityAnswer = this.UserDetailsForm.value.answer;
    this.userDetailsInfo.startDate = this.selectedstartdate;
    this.userDetailsInfo.roleName = this.UserDetailsForm.value.role;
    this.userDetailsInfo.isSupervising = this.UserDetailsForm.value.supervisingAccess;
    this.userDetailsInfo.epcs = this.UserDetailsForm.value.epcs;
    this.userDetailsInfo.salt = this.id.toString().substring(0, 32);
    this.userDetailsInfo.isActive = true;
    //this.userDetailsInfo.ownQuestion = null;
    this.userDetailsInfo.address1 = null;
    this.userDetailsInfo.address2 = null;
    this.userDetailsInfo.address3 = null;
    this.userDetailsInfo.state = null;
    this.userDetailsInfo.city = null;
    this.userDetailsInfo.postalCode = null;
    this.userDetailsInfo.postalCodeExt = null;
    this.userDetailsInfo.fax = null;
    this.userDetailsInfo.facilityId = Number(sessionStorage.getItem("FacilityId"));
    this.userDetailsInfo.clinic = this.UserDetailsForm.value.clinic;
    this.userDetailsInfo.ASC = this.UserDetailsForm.value.ASC;
    this.userDetailsInfo.billing = this.UserDetailsForm.value.billing;
    this.userDetailsInfo.locationIds = this.arryOfselectedLocationsIdsUpdate //this.UserDetailsForm.value.locations;
    this.userDetailsInfo.salutation = this.UserDetailsForm.value.salutation;
    this.userDetailsInfo.defaultLocationId = this.UserDetailsForm.value.primaryLocation;
  }

  clearAvailbility() {
    this.UserDetailsForm.patchValue({
      availbility: ''
    })
  }
  public selectedstartdate: any;
  onSubmit(): void {
    this.submitted = true;
    if (this.UserDetailsForm.invalid) {
      return;
    }
    this.selectedstartdate = this.datepipe.transform(this.UserDetailsForm.value.effectiveDate, 'yyyy-MM-dd');

    this.mapFormValuesToUserDetailsModel();
    if (this.UserDetailsForm.value.availbility == "User Id is Available") {
      var ownquestion = this.securityQuestion.filter(d => d.attributeId === this.UserDetailsForm.value.securityQuestion);
      if (ownquestion.length > 0) {
        if (ownquestion[0].attributeId === "140") {
          this.userDetailsInfo.securityQuestion = this.UserDetailsForm.value.securityQuestion;
          if (this.ownquestionanswar != "" && this.ownquestionanswar != null && this.ownquestionanswar != undefined) {
            this.userDetailsInfo.ownQuestion = this.ownquestionanswar;
            this.ownquestionanswar = "";
            this.userService.addUserInfo(this.userDetailsInfo).subscribe(data => {
              this.creationResult = data;
              this.toastr.success(this.creationResult);
              this.addedUserSuccess.emit(this.creationResult);
            });
          }
          else {
            this.toastr.error("Please Enter Own Question Answar");
          }
        }
        else {
          this.userDetailsInfo.securityQuestion = this.UserDetailsForm.value.securityQuestion;
          this.userDetailsInfo.ownQuestion = null;
          this.userService.addUserInfo(this.userDetailsInfo).subscribe(data => {
            this.creationResult = data;
            this.toastr.success(this.creationResult);
            this.addedUserSuccess.emit(this.creationResult);
          });
        }
      } else {
        this.userDetailsInfo.securityQuestion = this.UserDetailsForm.value.securityQuestion;
        this.userDetailsInfo.ownQuestion = null;
        this.userService.addUserInfo(this.userDetailsInfo).subscribe(data => {
          this.creationResult = data;
          this.toastr.success(this.creationResult);
          this.addedUserSuccess.emit(this.creationResult);
        });
      }
    }
    else {
      this.toastr.error("Please enter valid User Id");
    }
  }

  clearFormControlValues() {

    this.UserDetailsForm.patchValue({
      lastName: '',
      firstName: '',
      middleName: '',
      email: '',
      cellPhone: '',
      gender: '',
      userId: '',
      availbility: '',
      password: '',
      role: '',
      securityQuestion: '',
      answer: '',
      effectiveDate: '',
      ASC: '',
      billing: '',
      clinic: '',
      supervisingAccess: '',
      epcs: '',
      salutation: null,
      locations: null,
      primaryLocation: null,
    });
    this.locationNameUpdate = '';
    this.arryOfselectedLocationsIdsUpdate = [];
    this.locationsList = [];
    this.getLocations();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  ownquestionanswar: string = "";
  AddSecurityAnswar() {

    this.popUpText = "Own Question";
    const dialogRef = this.dialog.open(InputDialogComponent, {
      width: '250px',
      height: '160px',

      data: { headerText: "Enter " + this.popUpText, inputValue: '' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined) {

        var existList = this.securityQuestion.filter(x => x.attributeName.toLocaleLowerCase() === result.toLocaleLowerCase());
        if (existList.length > 0) {
          this.toastr.warning("This Security Question Already Exist");
          return;
        }

        this.sharedService.InsertSecurityQuestion(result, '23', 'squestion', 'Admin').subscribe(data => {
          this.toastr.success(data);

          this.sharedService.getSecurityQuestionById(23).subscribe(data => {
            this.securityQuestion = data;
          });
        });
        // this.ownquestionanswar = "";
        // this.ownquestionanswar = result;
      }
    });

  }

  public lstLocations: ILocationDetails[];
  getLocations() {
    this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
     
    });
  }

  focusOutNewPasswordFunction(event) {

  }

  onClickManageUser() {
    sessionStorage.setItem("DisplayCategeory", 'true');
    this.router.navigate(['/AdminSecurity']);
  }

  //********* Newly Added Multiselect dropdown */
  UsersFocus() {
    //  $('#Usersfocushide').show();
    this.SelectedDropDownListId = true;
  }
  focusOutFunctionLocation(evn) {
    if (evn.keyCode === 9) {
      $('#locationsfocushide').hide()
      setTimeout(() => {
        this.saveUserId.nativeElement.focus();
      }, 100);

      this.SelectedDropDownListId = false;
    } else if (evn.keyCode === 40 && evn.target.id == "locationsfocus") {
      $('#locationlistoption0').focus();
    }
  }

  locationNameUpdate: string;
  locationsList: ILocationDetails[];
  LocationSelectionChanged(LocationupdateRef) {

    this.locationsList = LocationupdateRef.selectedOptions.selected.map(item => item.value)
      .sort((a, b) => a.locationName.localeCompare(b.locationName));
    this.locationNameUpdate = '';
    let selectedLocationsIdsUpdate = []
      ; this.arryOfselectedLocationsIdsUpdate = [];
    for (let index = 0; index < this.locationsList.length; index++) {
      this.locationNameUpdate += this.locationsList[index].locationName + ', ';
      selectedLocationsIdsUpdate.push(this.locationsList[index].locationId);
      this.arryOfselectedLocationsIdsUpdate.push(this.locationsList[index].locationId.toString())
    }

    this.lstLocations.filter(x => x.selected = false) // default set false
    this.lstLocations.filter(x => selectedLocationsIdsUpdate.includes(x.locationId)).map(y => y.selected = true)

    // Primary/Home Location can only be one of the selected Locations — clear
    // it if a previously-chosen primary was just deselected here.
    if (!this.arryOfselectedLocationsIdsUpdate.includes(String(this.UserDetailsForm.value.primaryLocation))) {
      this.UserDetailsForm.patchValue({
        primaryLocation: ''
      });
    }

    this.UserDetailsForm.patchValue({
      locations: this.locationNameUpdate.substring(0, this.locationNameUpdate.length - 2)
    })
  }
}
